import React from 'react';
interface ProgressRingProps {
  progress: number; // 0 to 1
  size?: number;
  strokeWidth?: number;
  color?: string;
  backgroundColor?: string;
  children?: React.ReactNode;
}
const ProgressRing: React.FC<ProgressRingProps> = ({
  progress,
  size = 200,
  strokeWidth = 15,
  color = '#00E4BB',
  backgroundColor = '#002B36',
  children
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDashoffset = circumference - progress * circumference;
  return <div className="relative flex items-center justify-center" data-id="element-1518">
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`} className="transform -rotate-90" data-id="element-1519">
        {/* Background circle */}
        <circle cx={size / 2} cy={size / 2} r={radius} fill="transparent" stroke={backgroundColor} strokeWidth={strokeWidth} strokeOpacity={0.2} data-id="element-1520" />
        {/* Progress circle */}
        <circle cx={size / 2} cy={size / 2} r={radius} fill="transparent" stroke={color} strokeWidth={strokeWidth} strokeDasharray={circumference} strokeDashoffset={strokeDashoffset} strokeLinecap="round" className="transition-all duration-700 ease-out" data-id="element-1521">
          {/* Add subtle animation */}
          <animate attributeName="stroke-dashoffset" from={circumference} to={strokeDashoffset} dur="1s" fill="freeze" data-id="element-1522" />
        </circle>
      </svg>
      <div className="absolute flex items-center justify-center" data-id="element-1523">
        {children}
      </div>
    </div>;
};
export default ProgressRing;